import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'

import slidesSelector from '../selectors/slides'

import Footer from '../components/Footer'
import Header from '../components/Header'
import Slider from '../components/Slider'

import '../styles/Slideshow.css'

class Slideshow extends Component {
  render () {
    const {
      title,
      subtitle
    } = this.props.data

    return (
      <div className='Slideshow'>
        <Header bg='primary-1' />

        <Box align='center'>
          <Heading align='center' margin='none'>{title}</Heading>
          <Paragraph align='center' size='large'>{subtitle}</Paragraph>
          <Slider slides={this.props.slides} slideControlWidth={130} />
        </Box>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

Slideshow.propTypes = {
  data: PropTypes.object,
  slides: PropTypes.array,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  const {
    slides
  } = ownProps.data

  return {
    slides: slidesSelector(state, slides)
  }
}

export default connect(mapStateToProps)(Slideshow)



// WEBPACK FOOTER //
// ./src/layouts/Slideshow.js